import React from 'react'

import { useModalData } from '../../../components/modals/ModalsContext'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import { useExportSelectedServiceOrders } from './_requests/exportSelectedServiceOrders'

const ExportSelectedServiceOrdersForm = () => {
  const { ids } = useModalData() || {}
  const [startExport, { loading, error }] = useExportSelectedServiceOrders()

  return (
    <Form loading={loading} onSubmit={startExport} initialState={{ serviceOrderIds: ids }}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default ExportSelectedServiceOrdersForm
